import { Component } from '@angular/core';
import { PaymentInfo } from '$types'

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css'],
})
export class PaymentPageComponent {

  paymentInfo: PaymentInfo = { montant: 0, nomCheval: '' };

  setPaymentInfo(info: PaymentInfo) {
    this.paymentInfo = info;
  }
}
